if (!customElements.get('klaviyo-form')) {
	class KlaviyoForm extends HTMLElement {
		constructor() {
			super();

			this.querySelector('form').addEventListener('submit', async e => {
				e.preventDefault();
				this.querySelector('button').classList.add('show-loading', 'show-loading--inverted');

				let payload = {
					data: {
						type: 'subscription',
						attributes: {
							list_id: this.dataset.list,
							custom_source: this.dataset.source,
							email: this.querySelector('input[name="email"]').value,
							properties: {
								$first_name: this.querySelector('input[name="first_name"]').value
							}
						}
					}
				}

				let resp = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.dataset.store}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'revision': '2023-02-22'
					},
					body: JSON.stringify(payload)
				});

				if (resp.ok) {
					window.location.href = this.dataset.redirect;
				}
			});
		}
	}

	customElements.define('klaviyo-form', KlaviyoForm);
}